module.exports = {
          srcSet: __webpack_public_path__ + "d745ca69ce1ee852f0fa2507a745d377-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "d745ca69ce1ee852f0fa2507a745d377-180.png",width: 180,height: 12}],
          src: __webpack_public_path__ + "d745ca69ce1ee852f0fa2507a745d377-180.png",
          toString:function(){return __webpack_public_path__ + "d745ca69ce1ee852f0fa2507a745d377-180.png"},
          
          width: 180,
          height: 12
        }